// extracted by mini-css-extract-plugin
module.exports = {"badge":"L_nMOk1","badgeText":"Tfewe6g","badgeTextValue":"VpJtLZ3"};